import { Button, Col, Drawer, Form, notification, Row } from 'antd'
import moment from 'moment/moment'
import React from 'react'
import { connect } from 'react-redux'
import GetEachFormFields from '../../components/_utils/appFormUtils'
import { formItemLayout } from '../../components/_utils/appUtils'
import { addAbstractNoteFxn } from './actions'

@Form.create()
class AbstractNotesDrawer extends React.Component {
  handleSubmit = e => {
    const { form, abstractId, onClose } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        valData.abstractId = abstractId
        valData.time = moment().format('lll')

        let resp = await addAbstractNoteFxn(valData)

        if (resp && resp.success) {
          notification.success({
            message: resp.message || 'Note added successfully'
          })
          form.resetFields()
          onClose() // Closes the drawer immediately after successful addition
        }
      } else {
        notification.error({
          message: 'Please enter all required fields.'
        })
      }
    })
  }

  render() {
    const {
      form: { getFieldDecorator },
      visible,
      onClose
    } = this.props

    let inputSchema = [
      {
        label: 'Add Note',
        key: 'note',
        required: true,
        type: 'textArea',
        placeholder: 'Add Note'
      }
    ]

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        width={'70%'}
        title={'Add New Note'}>
        <Form
          onSubmit={this.handleSubmit}
          hideRequiredMark
          className={'inputForm'}>
          <Row gutter={16}>
            {inputSchema.map((item, key) => (
              <Col span={24} key={key}>
                <GetEachFormFields
                  item={item}
                  getFieldDecorator={getFieldDecorator}
                  formItemLayout={formItemLayout}
                />
              </Col>
            ))}
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Submit Note
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    )
  }
}

export default connect(null)(AbstractNotesDrawer)
